/**
 * TimeRole - Role para conversão de unidades de tempo/duração
 *
 * Implementa os 4 pilares: Convert, Cast, Validate, Format
 *
 * @example
 * const time = new TimeRole();
 * time.convert('hour', 'minute', 1)    // 60
 * time.cast('second', '5 min')         // 300
 * time.validate('second', 100)         // { valid: true, errors: [] }
 * time.format('hour', 2.5)             // "2.5 h"
 */

import { SimpleRole, type SimpleValidationConfig } from "../../contracts";
import { TIME_UNITS, TIME_ALIASES } from "./constants";

// =============================================================================
// TIME ROLE CLASS
// =============================================================================

export class TimeRole extends SimpleRole {
  readonly name = "time";
  readonly base = "second";
  readonly units = TIME_UNITS;
  readonly aliases = TIME_ALIASES;

  readonly validation: SimpleValidationConfig = {
    min: 0,
    minError: "Duration cannot be negative",
  };
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da TimeRole */
export const timeRole = new TimeRole();
